import { Component, OnInit, Inject } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";
import { Router } from "@angular/router";

@Component({
    selector: "app-import-dialog",
    templateUrl: "./import-dialog.component.html",
    styleUrls: ["./import-dialog.component.scss"],
    standalone: false
})
export class ImportDialogComponent implements OnInit {

  constructor(
    public dialogRef: VngDialogRef<ImportDialogComponent>,
    private router: Router,
    @Inject(VNG_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void { }

  cancel(): void {
    this.dialogRef.close();
  }

  navigateTo(plan: string): void {
    switch (plan) {
      case "flycuts":
        this.dialogRef.close();
        this.router.navigate(["/shortcuts/all"]);
        break;
      default:
          break;
    }
  }
}
